import { FC } from 'react';
import { Eye, Home } from 'react-feather';
import SideBarLink from './SideBarLink';
import { AuthConsumer } from '../../../containers/shared/auth/AuthContext';
import Can from '../../../containers/shared/auth/Can';
import HamburgerIcon from './HamburgerIcon';
import { Logo, LogoCont, SideBarWrapper, SideBarContent } from './StyledElements';
import { NavItem } from '.';
import { images } from '../../../theme';
import { isDSDRoute, isCapsiRoute } from '../../../utils';

type WebSideBarProps = {
  color?: string;
  context: any;
  isWeb?: boolean;
  navItems: Array<NavItem>;
  organisationLogo?: string;
  portalType: string;
};

const WebSideBar: FC<WebSideBarProps> = ({ color, context, isWeb, navItems, organisationLogo }) => {
  // a white-labelled host rebrands the whole portal, so it still wins; failing
  // that an organisation's uploaded logo stands in for the ImpactBoard default
  const customLogoImage = isDSDRoute
    ? images.dsdLogo
    : isCapsiRoute
    ? images.capsiLogo
    : organisationLogo || images.impactBoardLogoTp;

  return (
    <SideBarWrapper className="custom-sidebar" open={context.drawerOpen}>
      <LogoCont isWeb={isWeb} open={context.drawerOpen}>
        <HamburgerIcon onClick={context.toggleDrawer} open={context.drawerOpen} isWeb={isWeb} />
        <Logo
          open={context.drawerOpen}
          src={customLogoImage}
          alt={organisationLogo ? 'Organisation logo' : 'ImpactBoard'}
        />
      </LogoCont>
      <SideBarContent>
        <AuthConsumer>
          {({ user, hasCaseManagement }) => {
            const isViewerRole = user.roles.some(role => role.includes('VIEWER'));
            const landingObject = isViewerRole
              ? { title: 'Insights', icon: <Eye size={20} color="white" className="sidebar-menu-icon" /> }
              : { title: 'Dashboard', icon: <Home size={20} color="white" className="sidebar-menu-icon" /> };

            return (
              <>
                {navItems &&
                  navItems.length > 0 &&
                  navItems
                    .filter(k => k.title)
                    .map(i => (
                      <Can
                        landingPage={false}
                        key={i.to}
                        roles={user.roles}
                        plan={user.plan}
                        userAddOns={user.addOns}
                        action={`${i.to}:visit`}
                        navItemCheck={i.check ? i.check(user, hasCaseManagement) : undefined}
                        yes={() => (
                          <SideBarLink
                            to={i.to}
                            isWeb={isWeb}
                            key={isViewerRole && i.title === 'Dashboard' ? landingObject.title : i.title}
                            icon={isViewerRole && i.title === 'Dashboard' ? landingObject.icon : i.icon}
                            title={isViewerRole && i.title === 'Dashboard' ? landingObject.title : i.title}
                            subMenu={i.subMenu}
                            activePathPrefix={i.activePathPrefix}
                            color={color || 'white'}
                            open={context.drawerOpen}
                          />
                        )}
                        no={() => null}
                      />
                    ))}
              </>
            );
          }}
        </AuthConsumer>
      </SideBarContent>
    </SideBarWrapper>
  );
};

export default WebSideBar;
